import styled from "styled-components";

const Container = styled.div`
  margin: 1rem 0;
`;

const EditButton = styled.div<{ disabled: boolean }>`
  // This padding helps the edit button line up horizontally next to the placement check icons
  padding-top: 0.25rem;
  ${({ disabled }) => !disabled && `cursor: pointer;`}
  ${({ disabled }) => disabled && `filter: brightness(50%);`}
`;

const HasInfoIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

const Text = styled.div`
  text-align: left;

  > ul {
    padding-left: 1rem;
  }
`;

export { Container, EditButton, HasInfoIcon, Text };
